import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AMButton, ThemeButton } from '../components/AMButton'
import { AMSelector } from '../components/AMSelector'
import { AirMotor } from '../utils/types'
import { makeStyles } from '@material-ui/core/styles'
import { useMediaQuery } from '@material-ui/core'
import { theme } from '../utils/theme'
import { fetchMotorImage } from '../utils/api'

type MotorSelectType = {
  selectedMotor: AirMotor | null
  motors: AirMotor[]
  onChange: (id: string) => void
}

const useStyles = makeStyles(() => ({
  motorSelect: {
    textAlign: 'center',
  },
}))

export const MotorSelect = ({ selectedMotor, motors, onChange }: MotorSelectType) => {
  const [opened, setOpened] = useState(false)
  const [motorsDisplayed, setMotorsDisplayed] = useState(motors)
  const [images, setImages] = useState<{ [name: string]: string }>({})
  const { t } = useTranslation()
  const classes = useStyles()
  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    const loadImages = async () => {
      const newImages: { [name: string]: string } = {}
      for (const m of motors) {
        // Use productName as the product number for the API call
        const imgUrl = await fetchMotorImage(String(m.productName))
        newImages[m.name] = imgUrl
      }
      setImages(newImages)
    }
    loadImages()
  }, [motors])

  const options = motorsDisplayed.map((m) => ({
    value: m.name,
    label: m.name,
    img: images[m.name] === undefined ? undefined : images[m.name],
  }))

  useEffect(() => {
    if (opened) {
      setMotorsDisplayed(motors)
    } else {
      setMotorsDisplayed(motors.slice(0, 4))
    }
  }, [opened, motors])

  return (
    <div className={classes.motorSelect}>
      <AMSelector
        value={selectedMotor ? [selectedMotor.name] : []}
        options={options}
        onChange={(name: string) => onChange(motors.find((m) => m.name === name)!.id)}
        carousel={isMobileView}
      />
      {motors.length > 4 && !isMobileView && (
        <AMButton
          label={opened ? t('common.seeLess') : t('common.seeMore')}
          theme={ThemeButton.Black}
          onClick={() => setOpened(!opened)}
        />
      )}
    </div>
  )
}
